// Registration action types (UI state only - step navigation)
export const NEXT_STEP = "NEXT_STEP";
export const PREVIOUS_STEP = "PREVIOUS_STEP";
export const RESET_REGISTRATION_STATE = "RESET_REGISTRATION_STATE";

// Global logout action - resets all Redux state
export const LOGOUT = "LOGOUT";

// User actions types
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";
export const FETCH_USER_DATA_SUCCESS = "FETCH_USER_DATA_SUCCESS";
export const FETCH_USER_DATA_FAILURE = "FETCH_USER_DATA_FAILURE";
export const DEACTIVATE_USER_REQUEST = "DEACTIVATE_USER_REQUEST";
export const DEACTIVATE_USER_SUCCESS = "DEACTIVATE_USER_SUCCESS";
export const DEACTIVATE_USER_FAILURE = "DEACTIVATE_USER_FAILURE";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const UPDATE_CURRENT_USER = "UPDATE_CURRENT_USER";

// Social actions types
export const SET_FRIENDS_LIST = "SET_FRIENDS_LIST";
export const UPDATE_FRIEND_STATUS = "UPDATE_FRIEND_STATUS";

// Linkup actions types
export const SET_IS_LOADING = "SET_IS_LOADING";
export const ADD_LINKUP = "ADD_LINKUP";
export const REMOVE_LINKUP = "REMOVE_LINKUP";
export const UPDATE_LINKUP_SUCCESS = "UPDATE_LINKUP_SUCCESS";
export const UPDATE_LINKUP_FAILURE = "UPDATE_LINKUP_FAILURE";
export const FETCH_LINKUPS_SUCCESS = "FETCH_LINKUPS_SUCCESS";
export const FETCH_LINKUPS_FAILURE = "FETCH_LINKUPS_FAILURE";
export const UPDATE_LINKUP = "UPDATE_LINKUP";
export const MARK_LINKUPS_AS_EXPIRED_SUCCESS =
  "MARK_LINKUPS_AS_EXPIRED_SUCCESS";
export const SHOW_UPDATE_FEED_BUTTON = "SHOW_UPDATE_FEED_BUTTON";
export const MERGE_LINKUPS_SUCCESS = "MERGE_LINKUPS_SUCCESS";

// Editing linkup actions types
export const SET_EDITING_LINKUP = "SET_EDITING_LINKUP";
export const CLEAR_EDITING_LINKUP = "CLEAR_EDITING_LINKUP";

// Conversations action types
export const SET_CONVERSATIONS = "SET_CONVERSATIONS";
export const SET_SELECTED_CONVERSATION = "SET_SELECTED_CONVERSATION";
export const SET_MESSAGES = "SET_MESSAGES";
export const NEW_MESSAGE = "NEW_MESSAGE";
export const UPDATE_CONVERSATION = "UPDATE_CONVERSATION";
export const INCREMENT_UNREAD_COUNT = "INCREMENT_UNREAD_COUNT";
export const DECREMENT_UNREAD_COUNT = "DECREMENT_UNREAD_COUNT";
export const RESET_UNREAD_COUNT = "RESET_UNREAD_COUNT";
export const SET_IS_IN_CONVERSATION = "SET_IS_IN_CONVERSATION";

// Messaging action types
export const SET_UNREAD_MESSAGES_COUNT = "SET_UNREAD_MESSAGES_COUNT";
export const INCREMENT_UNREAD_MESSAGES_COUNT =
  "INCREMENT_UNREAD_MESSAGES_COUNT";
export const MARK_MESSAGES_AS_READ = "MARK_MESSAGES_AS_READ";

// Notifications action types
export const FETCH_UNREAD_NOTIFICATIONS_COUNT =
  "FETCH_UNREAD_NOTIFICATIONS_COUNT";
export const UPDATE_UNREAD_NOTIFICATIONS_COUNT =
  "UPDATE_UNREAD_NOTIFICATIONS_COUNT";
export const INCREMENT_UNREAD_NOTIFICATIONS_COUNT =
  "INCREMENT_UNREAD_NOTIFICATIONS_COUNT";
export const DECREMENT_UNREAD_NOTIFICATIONS_COUNT =
  "DECREMENT_UNREAD_NOTIFICATIONS_COUNT";

// User Sent Requests action types
export const ADD_SENT_REQUEST = "ADD_SENT_REQUEST";
export const FETCH_LINKUP_REQUESTS_SUCCESS = "FETCH_LINKUP_REQUESTS_SUCCESS";
export const FETCH_LINKUP_REQUESTS_ERROR = "FETCH_LINKUP_REQUESTS_ERROR";

// User Settings action types
export const SET_DEFAULT_SETTINGS = "SET_DEFAULT_SETTINGS";
export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const SAVE_USER_SETTINGS = "SAVE_USER_SETTINGS";
export const GET_USER_SETTINGS_SUCCESS = "GET_USER_SETTINGS_SUCCESS";
export const GET_USER_SETTINGS_FAILURE = "GET_USER_SETTINGS_FAILURE";
